import { render, staticRenderFns } from "./loginInfo.vue?vue&type=template&id=207bd97e"
import script from "./loginInfo.vue?vue&type=script&lang=js"
export * from "./loginInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports